var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div layout=\"row\" layout-align=\"center center\">\n<div layout=\"column\" layout-padding style=\"min-width:360px; width:550px;\">\n<sign-in-card scope=\"HubUSA.ASM.Api\" redirect-route=\"Overview\"></sign-in-card>\n</div>\n</div>\n";
var id1="components/security/sign-in.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./app/components/security/sign-in.html
// module id = 535
// module chunks = 0